module.exports = __webpack_public_path__ + "img/pause.f7d72922.png";